import { lazy } from "react";
import Protected from "../pages/auth/Protected";
import JoinRequest from "../pages/Coach/JoinRequest/JoinRequest.jsx";
const EventList = lazy(()=>import("../pages/Coach/Events/EventList.jsx"))
import CoachScheduler from "../pages/Coach/Scheduler/CoachScheduler.jsx";
import TeamList from "../pages/Coach/Team/TeamList.jsx";
import TeamPlayerList from "../pages/Coach/Team/TeamPlayerList.jsx";
import ChatRoom from "../pages/Coach/ChatRoom/ChatRoom.jsx";
import ChatBody from "../pages/Coach/ChatRoom/ChatBody.jsx";
import RegistrationSetup from "../pages/Coach/RegistrationSetup/RegistrationSetup.jsx";
import FormSettings from "../pages/Coach/RegistrationSetup/FormSettings/FormSettings.jsx";
import Registration from "../pages/Coach/Registration/Registration.jsx";
import ChildProfile from "../pages/Coach/Childrens/ChildProfile.jsx";
import EditPlayerInfo from "../pages/Coach/Roster/EditPlayerInfo.jsx";
import EventDetails from "../pages/Coach/Events/EventDetails.jsx";
const AddOraganization = lazy(() => import("../pages/Coach/AddOraganization/AddOraganization.jsx"));
const PlatformCoachPlans = lazy(() => import("../pages/Coach/Plan/PlatformCoachPlans"));
const Roster = lazy(() => import("../pages/Coach/Roster/Roster"));
const ChildrenList = lazy(() => import("../pages/Coach/Childrens/ChildrenList.jsx"));
const PlayerProfile = lazy(() => import("../pages/Coach/Roster/PlayerProfile.jsx"));

export const coachRoutes = [
    { path: "/coach-plan", element: <Protected Component={PlatformCoachPlans} /> },
    {
        path: "/roster",
        element: <Protected Component={Roster} />,
    },
    {
        path: "/add-org",
        element: <Protected Component={AddOraganization} />,
    },
    {
        path: "/join-requests",
        element: <Protected Component={JoinRequest} />,
    },
    {
        path: "/events",
        element: <Protected Component={EventList} />,
    },
    {
        path: "/my-kids",
        element: <Protected Component={ChildrenList} />,
    },
    {
        path: "/kid-profile/:childId",
        element: <Protected Component={ChildProfile} />,
    },
    {
        path: "/player-profile",
        element: <Protected Component={PlayerProfile} />,
    },
    {
        path: "/edit-player-info/:eventId",
        element: <Protected Component={EditPlayerInfo} />,

    },
    {
        path: "/coach-scheduler",
        element: <Protected Component={CoachScheduler} />,
    },
    {
        path: "/teams",
        element: <Protected Component={TeamList} />,
    },
    {
        path: "/team-players",
        element: <Protected Component={TeamPlayerList} />,
    },
    {
        path: "/registration-setup",
        element: <Protected Component={RegistrationSetup} />,
    },
    {
        path: "/form-settings",
        element: <Protected Component={FormSettings} />,
    },
    {
        path: "/registration",
        element: <Protected Component={Registration} />,
    },
    {
        path: "/event-details",
        element: <Protected Component={EventDetails} />,
    },
    {
        path: "/chat",
        element: <Protected Component={ChatRoom} />,
        children: [
            {
                path: "chat-body/:chatId",
                element: <Protected Component={ChatBody} />,

            },
        ]
    },
   
]